import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Client } from '../../../core/api-client';
import { API_GET_ALL_DOCUMENT_SUB_TYPE_LIST, API_DELETE_DOCUMENT_SUB_TYPE, API_CREATE_DOCUMENT_SUB_TYPE, API_UPDATE_DOCUMENT_SUB_TYPE } from '../../../shared/routes/private.routes';
import { DocumentSubType } from '../../../shared/types/common';

interface DocumentSubTypeState {
  documentSubTypeList: DocumentSubType[];
  loadingDocumentSubType: boolean;
  error: string | null;
  pagination: {
    page: number;
    limit: number;
    total: number;
  };
}

const initialState: DocumentSubTypeState = {
  documentSubTypeList: [],
  loadingDocumentSubType: false,
  error: null,
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
  },
};

export const getDocumentSubTypeList = createAsyncThunk(
  'documentSubType/getDocumentSubTypeList',
  async ({ params, body }: { params: any; body: any }, { rejectWithValue }) => {
    try {
      const response = await Client.post(API_GET_ALL_DOCUMENT_SUB_TYPE_LIST, body, { params });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createDocumentSubType = createAsyncThunk(
  'documentSubType/createDocumentSubType',
  async (documentSubTypeData: any, { rejectWithValue }) => {
    try {
      const response = await Client.post(API_CREATE_DOCUMENT_SUB_TYPE, documentSubTypeData);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateDocumentSubType = createAsyncThunk(
  'documentSubType/updateDocumentSubType',
  async ({ id, body }: { id: string; body: any }, { rejectWithValue }) => {
    try {
      const response = await Client.put(API_UPDATE_DOCUMENT_SUB_TYPE + id, body);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteDocumentSubType = createAsyncThunk(
  'documentSubType/deleteDocumentSubType',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await Client.delete(API_DELETE_DOCUMENT_SUB_TYPE + id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

const documentSubTypeSlice = createSlice({
  name: 'documentSubType',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDocumentSubTypeList.pending, (state) => { state.loadingDocumentSubType = true; state.error = null; })
      .addCase(getDocumentSubTypeList.fulfilled, (state, action) => { state.loadingDocumentSubType = false; state.documentSubTypeList = action.payload.data; state.pagination = action.payload.pagination; })
      .addCase(getDocumentSubTypeList.rejected, (state, action) => { state.loadingDocumentSubType = false; state.error = action.payload as string; })
      .addCase(createDocumentSubType.pending, (state) => { state.loadingDocumentSubType = true; state.error = null; })
      .addCase(createDocumentSubType.fulfilled, (state) => { state.loadingDocumentSubType = false; state.error = null; })
      .addCase(createDocumentSubType.rejected, (state, action) => { state.loadingDocumentSubType = false; state.error = action.payload as string; })
      .addCase(updateDocumentSubType.pending, (state) => { state.loadingDocumentSubType = true; state.error = null; })
      .addCase(updateDocumentSubType.fulfilled, (state) => { state.loadingDocumentSubType = false; state.error = null; })
      .addCase(updateDocumentSubType.rejected, (state, action) => { state.loadingDocumentSubType = false; state.error = action.payload as string; })
      .addCase(deleteDocumentSubType.pending, (state) => { state.loadingDocumentSubType = true; state.error = null; })
      .addCase(deleteDocumentSubType.fulfilled, (state) => { state.loadingDocumentSubType = false; state.error = null; })
      .addCase(deleteDocumentSubType.rejected, (state, action) => { state.loadingDocumentSubType = false; state.error = action.payload as string; });
  },
});

export default documentSubTypeSlice.reducer;
